import { render } from "./dimension_garage.vue?vue&type=template&id=5124dc05&scoped=true"
import script from "./dimension_garage.vue?vue&type=script&lang=js"
export * from "./dimension_garage.vue?vue&type=script&lang=js"

import "./dimension_garage.vue?vue&type=style&index=0&id=5124dc05&scoped=true&lang=css"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5124dc05"]])

export default __exports__